module.exports = "../../app/cells/pages/institute/menu_bar_float_cell.rb";